import React, { Component } from "react";
import PropTypes from "prop-types";
import { FilterListRounded } from "@mui/icons-material";

import { NoPrintDiv } from "commons";

import { MenuButton } from "./MenuButton";
import { FilterSelect } from "./FilterSelect";

export class FilterSelectParent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showPanel: false
        };
        this.containerRef = React.createRef();
    }

    componentWillUnmount() {
        document.removeEventListener("click", this.handleOutsideClick, false);
    }

    getContainerRef = () => this.containerRef.current;

    handleClick = e => {
        e.stopPropagation();
        if (!this.state.menuVisible && !this.props.disabled) {
            document.addEventListener("click", this.handleOutsideClick, false);
            this.setState({ showPanel: true });
        }
    };

    handleOutsideClick = e => {
        if (this.getContainerRef() && !this.getContainerRef().contains(e.target)) {
            this.hidePanel();
        }
    };

    hidePanel = () => {
        document.removeEventListener("click", this.handleOutsideClick, false);
        this.setState({ showPanel: false });
    };

    render() {
        return (
            <NoPrintDiv float="left">
                <MenuButton
                    clickEvent={this.handleClick}
                    text="Filter transactions"
                    disabled={this.props.disabled}
                    icon={<FilterListRounded color="primary" fontSize="small" />}
                />
                <div ref={this.containerRef}>
                    <FilterSelect
                        reference={this.myRef}
                        shown={this.state.showPanel}
                        options={this.props.options}
                        filterSelect={this.props.filterSelect}
                        ordinals={this.props.ordinals}
                        hidePanel={this.hidePanel}
                    />
                </div>
            </NoPrintDiv>
        );
    }
}

FilterSelectParent.propTypes = {
    options: PropTypes.object,
    filterSelect: PropTypes.func,
    ordinals: PropTypes.array,
    disabled: PropTypes.bool
};
